import React from "react";
import { DatePicker } from "@design-system/DatePicker/DatePicker";
import { Field, pickFieldControlAriaProps } from "@design-system/Field/Field";
import { TextArea } from "@design-system/TextArea/TextArea";
import styles from "./EliminatingEntryDrawer.module.scss";

interface Props {
    date: string;
    reversedAt: string | null;
    memo: string;
    disabled?: boolean;
    onReversedAtChange: (reversedAt: string | null) => void;
    onMemoChange: (memo: string) => void;
}

export const EliminatingEntrySidebar: React.FC<Props> = ({
    date,
    reversedAt,
    memo,
    disabled = false,
    onReversedAtChange,
    onMemoChange,
}) => (
    <div className={styles.sidebar}>
        <h6 className={styles.sectionHeader}>Details</h6>
        <Field
            className={styles.fieldContainer}
            label="Reverse date"
            control="button"
        >
            <Field.Control
                render={(controlProps) => (
                    <DatePicker
                        mode="day"
                        variant="panel-input"
                        className={styles.dateInput}
                        clearable
                        minDate={date}
                        placeholder="Add reversal"
                        value={reversedAt ?? undefined}
                        disabled={disabled}
                        onValueChange={(value) =>
                            onReversedAtChange(value ?? null)
                        }
                        buttonProps={{
                            variant: "secondary",
                            size: "lg",
                            block: true,
                        }}
                        fieldControlProps={pickFieldControlAriaProps(
                            controlProps,
                        )}
                    />
                )}
            />
        </Field>
        <Field label="Memo" className={styles.fieldContainer}>
            <TextArea
                className={styles.memoTextarea}
                size="xl"
                placeholder="Add memo"
                value={memo}
                disabled={disabled}
                onChange={(event) => onMemoChange(event.target.value)}
                rows={3}
                resizable
            />
        </Field>
        <p className={styles.subtitle}>
            Group-level eliminating adjustment. Posts to the consolidation
            overlay ledger and affects the consolidated report only.
        </p>
    </div>
);
